import { render, staticRenderFns } from "./ourRequests.vue?vue&type=template&id=08b11bc6&scoped=true"
import script from "./ourRequests.vue?vue&type=script&lang=js"
export * from "./ourRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b11bc6",
  null
  
)

export default component.exports